import { render, staticRenderFns } from "./VolunteerBackendNotificationComponent.vue?vue&type=template&id=14862f2b&"
import script from "./VolunteerBackendNotificationComponent.vue?vue&type=script&lang=js&"
export * from "./VolunteerBackendNotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerBackendNotificationComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports